import { Trash2 } from "lucide-react";

export function FileUploaded({
  name,
  onDelete,
}: {
  name: string;
  onDelete: () => void;
}) {
  return (
    <div className="border pt-2 pb-2 pl-2 pr-2 flex justify-between items-center rounded-sm mt-1 border-border-secondary">
      <p className="text-sm text-text-secondary font-medium truncate max-w-full">
        {name}
      </p>
      <div className="flex items-center">
        <button className="cursor-pointer mr-1 ml-1" onClick={onDelete}>
          <Trash2 className="text-[#d92d20]" size={20} />
        </button>
      </div>
    </div>
  );
}
